const waitFor = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const expBackoffDelay = (base, max) => {
  let current = base / 2

  return () => {
    current = 2 * current

    if (current > max) {
      return 0
    }

    return current
  }
}

const loopUtil = async (logicFn, shouldStopFn, delayFn, onMetaChange) => {
  const result = await logicFn()

  const stop = shouldStopFn(result)
  const nextDelayMs = delayFn()

  if (onMetaChange) {
    onMetaChange({ timeoutMs: nextDelayMs, stop })
  }

  if (stop || !nextDelayMs) {
    return {
      ...result,
      isTimedOut: !nextDelayMs,
    }
  }

  await waitFor(nextDelayMs)
  return loopUtil(logicFn, shouldStopFn, delayFn, onMetaChange)
}

export { waitFor, expBackoffDelay, loopUtil }
